import type {
  PermissionAccessRoleDto,
  PermissionDataDto,
  PermissionDto,
  PermissionRequestDto,
  PermissionScreenDto,
} from '../dto';
import type {
  PermissionData,
  PermissionRequest,
  Permision,
  PermisionAccessRole,
  PermisionScreen,
} from '../models';

export const mapPermissionAccessRoleDtoToModel = (
  dto: PermissionAccessRoleDto,
): PermisionAccessRole => ({ ...dto });

export const mapPermissionScreenDtoToModel = (
  dto: PermissionScreenDto,
): PermisionScreen => ({
  ...dto,
  accessRoles: dto.accessRoles.map(mapPermissionAccessRoleDtoToModel),
});

export const mapPermissionDtoToModel = (dto: PermissionDto): Permision => ({
  ...dto,
  accessRoles: dto.accessRoles.map(mapPermissionAccessRoleDtoToModel),
  screens: dto.screens.map(mapPermissionScreenDtoToModel),
});

export const mapPermissionsListDtoToModel = (
  dtos: PermissionDto[],
): Permision[] => dtos.map(mapPermissionDtoToModel);

export const mapPermissionDataDtoToModel = (
  dto: PermissionDataDto,
): PermissionData => ({
  ...dto,
  permissions: mapPermissionsListDtoToModel(dto.permissions),
});

export const mapPermissionRequestModelToDto = (
  request: PermissionRequest,
): PermissionRequestDto => ({
  data: request.data.map((permission) => ({
    ...permission,
    accessRoles: permission.accessRoles.map((accessRole) => ({
      ...accessRole,
    })),
    screens: permission.screens.map((screen) => ({
      ...screen,
      accessRoles: screen.accessRoles.map((accessRole) => ({ ...accessRole })),
    })),
  })),
});
